
export const SP_LANDING = 'SP_LANDING';
export const EXTRA_QUESTION_MAX_LENGTH = 1024;
export const BACK_URL = 'BackUrl';
// matches summit-api SpeakerService::addSpeakerPhoto / addSpeakerBigPhoto max_file_size (10 MB)
export const SPEAKER_PHOTO_MAX_SIZE = 10485760;
